export default "__VITE_ASSET__Carej3Ve__"